import React from 'react';
import Button from 'flow/components/ui-components/Button';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    onClickSave: () => void;
    onClickDelete: () => void;
    createIsAllowed: boolean;
    isEditingExistingDashboard: boolean;
}
const DashboardButtonsModify = ({
    createIsAllowed,
    isEditingExistingDashboard,
    onClickDelete,
    onClickSave,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="flex items-center justify-end gap-x-3">
            {isEditingExistingDashboard ? (
                <Button onClick={onClickDelete} className="text-red p-2">
                    {i18next.t('wallboard.delete')}
                </Button>
            ) : null}
            <Button
                color="primary"
                onClick={onClickSave}
                disabled={!createIsAllowed}
                className="p-2"
            >
                {isEditingExistingDashboard
                    ? i18next.t('wallboard.save')
                    : i18next.t('wallboard.create')}
            </Button>
        </div>
    );
};

export default DashboardButtonsModify;
